import React, { useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { websiteDetail } from "../utils/common.data";
import { footerDetail } from "../utils/data";

const Footer = () => {
  const location = useLocation(); // Get the current path
  useEffect(() => {
    const handleScrollToTop = () => {
      window.scrollTo({ top: 0, behavior: "smooth" });
    };
    handleScrollToTop();
  }, []);

  return (
    <section>
      <section className="tj-footer">
        <div className="container">
          <div className="row">
            <div className="col-md-5">
              <div className="about-widget widget">
                <h3>About {websiteDetail.title}</h3>
                <p>{footerDetail.description}</p>
                <ul className="fsocial-links">
                  {process.env.REACT_APP_FACEBOOK_URL && (
                    <li>
                      <a
                        href={process.env.REACT_APP_FACEBOOK_URL}
                        target="_blank"
                        rel="noreferrer"
                      >
                        <i className="fab fa-facebook-f"></i>
                      </a>
                    </li>
                  )}
                  {process.env.REACT_APP_TWITTER_URL && (
                    <li>
                      <a
                        href={process.env.REACT_APP_TWITTER_URL}
                        target="_blank"
                        rel="noreferrer"
                      >
                        <i className="fab fa-twitter"></i>
                      </a>
                    </li>
                  )}

                  {process.env.REACT_APP_LINKED_IN_URL && (
                    <li>
                      <a
                        href={process.env.REACT_APP_LINKED_IN_URL}
                        target="_blank"
                        rel="noreferrer"
                      >
                        <i className="fab fa-linkedin-in"></i>
                      </a>
                    </li>
                  )}

                  {process.env.REACT_APP_PINTEREST_URL && (
                    <li>
                      <a
                        href={process.env.REACT_APP_PINTEREST_URL}
                        target="_blank"
                        rel="noreferrer"
                      >
                        <i className="fab fa-pinterest-p"></i>
                      </a>
                    </li>
                  )}
                  {process.env.REACT_APP_INSTRAGRAM_URL && (
                    <li>
                      <a
                        href={process.env.REACT_APP_INSTRAGRAM_URL}
                        target="_blank"
                        rel="noreferrer"
                      >
                        <i className="fab fa-instagram"></i>
                      </a>
                    </li>
                  )}
                </ul>
              </div>
            </div>

            <div className="col-md-3">
              <div
                className="links-widget widget"
                style={{ marginBottom: "20px" }}
              >
                <h3>Quick Links</h3>
                <ul className="flinks-list">
                  {![
                    "/term_condition",
                    "/privacy_policy",
                    "/about_us",
                  ].includes(location.pathname) ? (
                    <>
                      <li>
                        <i className="fas fa-info-circle"></i>
                        <Link to="/about-us">About Us</Link>
                      </li>
                      <li>
                        <i className="fas fa-briefcase"></i>
                        <Link to="/services">Services</Link>
                      </li>
                      <li>
                        <i className="fas fa-paper-plane"></i>
                        <Link to="/contact-us">Contact Us</Link>
                      </li>
                      <li>
                        <i className="fas fa-shield-alt"></i>
                        <Link to="/privacy-policy">Privacy Policy</Link>
                      </li>
                      <li>
                        <i className="fas fa-file-signature"></i>
                        <Link to="/term-condition">Terms & Conditions</Link>
                      </li>
                    </>
                  ) : (
                    <>
                      <li>
                        <i className="fas fa-info-circle"></i>
                        <Link to="/about_us">About Us</Link>
                      </li>
                      <li>
                        <i className="fas fa-shield-alt"></i>
                        <Link to="/privacy_policy">Privacy Policy</Link>
                      </li>
                      <li>
                        <i className="fas fa-file-signature"></i>
                        <Link to="/term_condition">Terms & Conditions</Link>
                      </li>
                    </>
                  )}
                </ul>
              </div>
            </div>

            <div className="col-md-4">
              <div className="contact-info widget contact_info_footer_main">
                <h3>Contact Info</h3>
                <ul className="contact-box contact_info_footer_main_box">
                  {/* <li>
                    <i className="fas fa-home" aria-hidden="true"></i>{" "}
                    {process.env.REACT_APP_BUSINESS_ADDRESS}
                  </li> */}
                  <li>
                    <i className="fas fa-home" aria-hidden="true"></i>{" "}
                    <span>{websiteDetail.address}</span>
                  </li>
                  <li>
                    <i className="far fa-envelope-open"></i>
                    {/* <a href={`mailto:${process.env.REACT_APP_BUSINESS_EMAIL}`}>
                      {process.env.REACT_APP_BUSINESS_EMAIL}
                    </a> */}
                    <a href={`mailto:${websiteDetail.email}`}>
                      <span>{websiteDetail.email}</span>
                    </a>
                  </li>
                  <li>
                    <i className="fas fa-phone-square"></i>
                    <a
                      href={`tel:${websiteDetail.countryCode}${websiteDetail.mobile}`}
                    >
                      {websiteDetail.phoneNumber}
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* <!--Footer Content End--> */}
      {/* <!--Footer Copyright Start--> */}
      <section className="tj-copyright">
        <div className="container" style={{ textAlign: "center" }}>
          <div className="">
            <div className="">
              <div>
                {/*     <p>
               {copyright}
              </p> */}
                <p style={{ textAlign: "center", float: "none" }}>
                  {/* &copy; Copyrights {new Date().getFullYear()}{" "}
                  {websiteDetail.title}. All Rights Reserved. */}
                  © Copyright {new Date().getFullYear()} Grepix Infotech Private
                  Limited, operating as Hireme Rides. All Rights Reserved.
                </p>
              </div>

              {/* <div className="priv-term">
                <Link to={!["/term_condition", "/privacy_policy","/about_us"].includes(location.pathname) ? "/term-condition":  "/term_condition"}>Terms & conditions</Link>
                <Link to={!["/term_condition", "/privacy_policy","/about_us"].includes(location.pathname) ?"/privacy-policy":"/privacy_policy"}>Privacy policy</Link>
              </div> */}
            </div>
          </div>
        </div>
      </section>
    </section>
  );
};
export default Footer;
